import SrpErrorState from './SrpErrorState'

const SrpErrorStateWrapper = ({
    pastDateError,
    errorStatus = 500
}: {
    pastDateError: boolean
    errorStatus: number
}) => {
    return <SrpErrorState pastDateError={pastDateError} errorStatus={errorStatus} />
}

export default SrpErrorStateWrapper
